import brandedFooterInterrupter from './branded-footer-interrupter';
import setBrandedFooter from './set-branded-footer';

export default {
  brandedFooterInterrupter,
  setBrandedFooter,
};
